// extracted by mini-css-extract-plugin
export default {"office":"office-module--office--dSJUr","image":"office-module--image--8O9p7","illustration":"office-module--illustration--+2ciu","address":"office-module--address--jGIja"};